The input parameter for the `updateWebhookSubscriptionSigningConfiguration` mutation.
